export default {"src":"/_next/static/media/surgeon_24.a46927be.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};